module.exports = __webpack_public_path__ + "static/Zam.0ae037bc.png";